import "intersection-observer";

import React, { useEffect, useRef, useState } from "react";

import css from "./video.module.scss";
import playImg from "../../../static/images/play-btn.svg";

const noop = () => {};

function useOnScreen(ref, rootMargin = "-100px") {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin
      }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref, rootMargin]);
  return isIntersecting;
}
export default function Video({
  image,
  glance,
  index,
  onPlay = noop,
  onPause = noop
}) {
  const ref = useRef();
  const onScreen = useOnScreen(ref);
  const [playBtnClicked, setPlayBtnClicked] = useState(false);

  useEffect(
    function() {
      if (playBtnClicked && onScreen) {
        ref.current.play();
        onPlay();
      } else if (!onScreen) {
        ref.current.pause();
        onPause();
      }
    },
    [onScreen, playBtnClicked, onPlay, onPause]
  );
  function videoHandler(e) {
    if (e.currentTarget.children[0].paused) {
      e.currentTarget.children[0].play();
      setPlayBtnClicked(true);
      onPlay();
    } else {
      e.currentTarget.children[0].pause();
      setPlayBtnClicked(false);
      onPause();
    }
  }
  const video = glance.peek.nativeVideoPeek.videoUrl;
  return video ? (
    <div className={css["resp-container"]} onClick={videoHandler}>
      <video
        ref={ref}
        loop
        playsInline
        autoPlay="autoplay"
        poster={image}
        muted={false}
        className={css["vertical-video"]}
      >
        <source src={video} onClick={videoHandler} />
      </video>
      {!playBtnClicked ? (
        <div className={css["video"]}>
          <div className={css["videoBtn"]}>
            <img
              src={playImg}
              alt="video thumbnail"
              className={css["width100"]}
            />
          </div>
        </div>
      ) : null}
    </div>
  ) : null;
}
